import { SOURCE_LABELS } from "./constants";

export function getFilterLabel(key, value) {
  if (value == null || value === "") return value;
  if (key === "source") return SOURCE_LABELS[value] || value;
  if (key === "date_from" || key === "date_to") {
    return value
      ? new Date(value).toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        })
      : value;
  }
  return value;
}
